import React from 'react'
import { RightOutlined } from '@ant-design/icons'

interface IVeeSuggestionRowProps {
  label: string
  onClick: () => void
}

export const VeeSuggestionRow: React.FC<IVeeSuggestionRowProps> = ({ label, onClick }) => (
  <button type="button" className="vee-suggestion-row" onClick={onClick}>
    <span>{label}</span>
    <RightOutlined aria-hidden />
  </button>
)
